import React from 'react';

interface DemoCursorProps {
  x: number;
  y: number;
  visible: boolean;
  /** Whether audio is currently playing */
  audioPlaying?: boolean;
}

/** Animated demo cursor - standard arrow pointer, black/light white/dark */
export const DemoCursor: React.FC<DemoCursorProps> = ({ x, y, visible }) => {
  return (
    <div
      className="fixed pointer-events-none transition-all duration-1000 ease-in-out"
      style={{
        zIndex: 9999,
        left: x,
        top: y,
        opacity: visible ? 1 : 0,
        transform: 'translate(-2px, -2px)',
      }}
    >
      <svg width="20" height="28" viewBox="0 0 20 28" fill="none">
        {/* Outer stroke for contrast */}
        <path
          d="M1 1L1 22L6.5 16.5L11 26L14 24.5L9.5 15H17L1 1Z"
          className="stroke-white dark:stroke-neutral-900"
          strokeWidth="2.5"
          strokeLinejoin="round"
          fill="none"
        />
        {/* Fill */}
        <path
          d="M1 1L1 22L6.5 16.5L11 26L14 24.5L9.5 15H17L1 1Z"
          className="fill-black dark:fill-white"
        />
      </svg>
    </div>
  );
};
